// Coastal
import coastal01jpeg from 'assets/img/homeownerApp/samples/interior/Coastal/01.jpeg';
import coastal02jpeg from 'assets/img/homeownerApp/samples/interior/Coastal/02.jpeg';
import coastal03jpeg from 'assets/img/homeownerApp/samples/interior/Coastal/03.jpeg';
import coastal04jpeg from 'assets/img/homeownerApp/samples/interior/Coastal/04.jpeg';
import coastal05jpeg from 'assets/img/homeownerApp/samples/interior/Coastal/05.jpeg';
import coastal06jpeg from 'assets/img/homeownerApp/samples/interior/Coastal/06.jpeg';
import coastal07jpeg from 'assets/img/homeownerApp/samples/interior/Coastal/07.jpeg';
import coastal08jpeg from 'assets/img/homeownerApp/samples/interior/Coastal/08.jpeg';
import coastal09jpeg from 'assets/img/homeownerApp/samples/interior/Coastal/09.jpeg';
// Contemporary
import contemporary01jpeg from 'assets/img/homeownerApp/samples/interior/Contemporary/01.jpeg';
import contemporary02jpeg from 'assets/img/homeownerApp/samples/interior/Contemporary/02.jpeg';
import contemporary03jpeg from 'assets/img/homeownerApp/samples/interior/Contemporary/03.jpeg';
import contemporary04jpeg from 'assets/img/homeownerApp/samples/interior/Contemporary/04.jpeg';
import contemporary05jpeg from 'assets/img/homeownerApp/samples/interior/Contemporary/05.jpeg';
import contemporary06jpeg from 'assets/img/homeownerApp/samples/interior/Contemporary/06.jpeg';
import contemporary07jpeg from 'assets/img/homeownerApp/samples/interior/Contemporary/07.jpeg';
import contemporary08jpeg from 'assets/img/homeownerApp/samples/interior/Contemporary/08.jpeg';
import contemporary09jpeg from 'assets/img/homeownerApp/samples/interior/Contemporary/09.jpeg';
// Eclectic
import eclectic01jpeg from 'assets/img/homeownerApp/samples/interior/Eclectic/01.jpeg';
import eclectic02jpeg from 'assets/img/homeownerApp/samples/interior/Eclectic/02.jpeg';
import eclectic03jpeg from 'assets/img/homeownerApp/samples/interior/Eclectic/03.jpeg';
import eclectic04jpeg from 'assets/img/homeownerApp/samples/interior/Eclectic/04.jpeg';
import eclectic05jpeg from 'assets/img/homeownerApp/samples/interior/Eclectic/05.jpeg';
import eclectic06jpeg from 'assets/img/homeownerApp/samples/interior/Eclectic/06.jpeg';
import eclectic07jpeg from 'assets/img/homeownerApp/samples/interior/Eclectic/07.jpeg';
import eclectic08jpeg from 'assets/img/homeownerApp/samples/interior/Eclectic/08.jpeg';
import eclectic09jpeg from 'assets/img/homeownerApp/samples/interior/Eclectic/09.jpeg';
import eclectic10jpeg from 'assets/img/homeownerApp/samples/interior/Eclectic/10.jpeg';
// Farmhouse
import farmhouse01jpeg from 'assets/img/homeownerApp/samples/interior/Farmhouse/01.jpeg';
import farmhouse02jpeg from 'assets/img/homeownerApp/samples/interior/Farmhouse/02.jpeg';
import farmhouse03jpeg from 'assets/img/homeownerApp/samples/interior/Farmhouse/03.jpeg';
import farmhouse04jpeg from 'assets/img/homeownerApp/samples/interior/Farmhouse/04.jpeg';
import farmhouse05jpeg from 'assets/img/homeownerApp/samples/interior/Farmhouse/05.jpeg';
import farmhouse06jpeg from 'assets/img/homeownerApp/samples/interior/Farmhouse/06.jpeg';
import farmhouse07jpeg from 'assets/img/homeownerApp/samples/interior/Farmhouse/07.jpeg';
import farmhouse08jpeg from 'assets/img/homeownerApp/samples/interior/Farmhouse/08.jpeg';
import farmhouse09jpeg from 'assets/img/homeownerApp/samples/interior/Farmhouse/09.jpeg';
// French Country
import frenchCountry01jpeg from 'assets/img/homeownerApp/samples/interior/FrenchCountry/01.jpeg';
import frenchCountry02jpeg from 'assets/img/homeownerApp/samples/interior/FrenchCountry/02.jpeg';
import frenchCountry03jpeg from 'assets/img/homeownerApp/samples/interior/FrenchCountry/03.jpeg';
import frenchCountry04jpeg from 'assets/img/homeownerApp/samples/interior/FrenchCountry/04.jpeg';
import frenchCountry05jpeg from 'assets/img/homeownerApp/samples/interior/FrenchCountry/05.jpeg';
import frenchCountry06jpeg from 'assets/img/homeownerApp/samples/interior/FrenchCountry/06.jpeg';
import frenchCountry07jpeg from 'assets/img/homeownerApp/samples/interior/FrenchCountry/07.jpeg';
import frenchCountry08jpeg from 'assets/img/homeownerApp/samples/interior/FrenchCountry/08.jpeg';
// Glam
import glam01jpeg from 'assets/img/homeownerApp/samples/interior/Glam/01.jpeg';
import glam02jpeg from 'assets/img/homeownerApp/samples/interior/Glam/02.jpeg';
import glam03jpeg from 'assets/img/homeownerApp/samples/interior/Glam/03.jpeg';
import glam04jpeg from 'assets/img/homeownerApp/samples/interior/Glam/04.jpeg';
import glam05jpeg from 'assets/img/homeownerApp/samples/interior/Glam/05.jpeg';
import glam06jpeg from 'assets/img/homeownerApp/samples/interior/Glam/06.jpeg';
import glam07jpeg from 'assets/img/homeownerApp/samples/interior/Glam/07.jpeg';
import glam08jpeg from 'assets/img/homeownerApp/samples/interior/Glam/08.jpeg';
import glam09jpeg from 'assets/img/homeownerApp/samples/interior/Glam/09.jpeg';
// Mediterranean
import mediterranean01jpeg from 'assets/img/homeownerApp/samples/interior/Mediterranean/01.jpeg';
import mediterranean02jpeg from 'assets/img/homeownerApp/samples/interior/Mediterranean/02.jpeg';
import mediterranean03jpeg from 'assets/img/homeownerApp/samples/interior/Mediterranean/03.jpeg';
import mediterranean04jpeg from 'assets/img/homeownerApp/samples/interior/Mediterranean/04.jpeg';
import mediterranean05jpeg from 'assets/img/homeownerApp/samples/interior/Mediterranean/05.jpeg';
import mediterranean06jpeg from 'assets/img/homeownerApp/samples/interior/Mediterranean/06.jpeg';
import mediterranean07jpeg from 'assets/img/homeownerApp/samples/interior/Mediterranean/07.jpeg';
import mediterranean08jpeg from 'assets/img/homeownerApp/samples/interior/Mediterranean/08.jpeg';
import mediterranean09jpeg from 'assets/img/homeownerApp/samples/interior/Mediterranean/09.jpeg';
// Mid-Century Modern
import midCenturyModern01jpeg from 'assets/img/homeownerApp/samples/interior/MidCenturyModern/01.jpeg';
import midCenturyModern02jpeg from 'assets/img/homeownerApp/samples/interior/MidCenturyModern/02.jpeg';
import midCenturyModern03jpeg from 'assets/img/homeownerApp/samples/interior/MidCenturyModern/03.jpeg';
import midCenturyModern04jpeg from 'assets/img/homeownerApp/samples/interior/MidCenturyModern/04.jpeg';
// Spanish
import spanish01jpeg from 'assets/img/homeownerApp/samples/interior/Spanish/01.jpeg';
import spanish02jpeg from 'assets/img/homeownerApp/samples/interior/Spanish/02.jpeg';
import spanish03jpeg from 'assets/img/homeownerApp/samples/interior/Spanish/03.jpeg';
import spanish04jpeg from 'assets/img/homeownerApp/samples/interior/Spanish/04.jpeg';
import spanish05jpeg from 'assets/img/homeownerApp/samples/interior/Spanish/05.jpeg';
import spanish06jpeg from 'assets/img/homeownerApp/samples/interior/Spanish/06.jpeg';
import spanish07jpeg from 'assets/img/homeownerApp/samples/interior/Spanish/07.jpeg';
import spanish08jpeg from 'assets/img/homeownerApp/samples/interior/Spanish/08.jpeg';
// Traditional
import traditional01jpeg from 'assets/img/homeownerApp/samples/interior/Traditional/01.jpeg';
import traditional02jpeg from 'assets/img/homeownerApp/samples/interior/Traditional/02.jpeg';
import traditional03jpeg from 'assets/img/homeownerApp/samples/interior/Traditional/03.jpeg';
import traditional04jpeg from 'assets/img/homeownerApp/samples/interior/Traditional/04.jpeg';
import traditional05jpeg from 'assets/img/homeownerApp/samples/interior/Traditional/05.jpeg';
import traditional06jpeg from 'assets/img/homeownerApp/samples/interior/Traditional/06.jpeg';
import traditional07jpeg from 'assets/img/homeownerApp/samples/interior/Traditional/07.jpeg';
import traditional08jpeg from 'assets/img/homeownerApp/samples/interior/Traditional/08.jpeg';
import traditional09jpeg from 'assets/img/homeownerApp/samples/interior/Traditional/09.jpeg';
import traditional10jpeg from 'assets/img/homeownerApp/samples/interior/Traditional/10.jpeg';

import type { ISamplePath } from './sampleImages';

/* eslint-disable prettier/prettier */

export const interiorSamples: ISamplePath[] = [
  // Coastal
  { style: 'Coastal', jpeg: coastal01jpeg },
  { style: 'Coastal', jpeg: coastal02jpeg },
  { style: 'Coastal', jpeg: coastal03jpeg },
  { style: 'Coastal', jpeg: coastal04jpeg },
  { style: 'Coastal', jpeg: coastal05jpeg },
  { style: 'Coastal', jpeg: coastal06jpeg },
  { style: 'Coastal', jpeg: coastal07jpeg },
  { style: 'Coastal', jpeg: coastal08jpeg },
  { style: 'Coastal', jpeg: coastal09jpeg },
  // Contemporary
  { style: 'Contemporary', jpeg: contemporary01jpeg },
  { style: 'Contemporary', jpeg: contemporary02jpeg },
  { style: 'Contemporary', jpeg: contemporary03jpeg },
  { style: 'Contemporary', jpeg: contemporary04jpeg },
  { style: 'Contemporary', jpeg: contemporary05jpeg },
  { style: 'Contemporary', jpeg: contemporary06jpeg },
  { style: 'Contemporary', jpeg: contemporary07jpeg },
  { style: 'Contemporary', jpeg: contemporary08jpeg },
  { style: 'Contemporary', jpeg: contemporary09jpeg },
  // Eclectic
  { style: 'Eclectic', jpeg: eclectic01jpeg },
  { style: 'Eclectic', jpeg: eclectic02jpeg },
  { style: 'Eclectic', jpeg: eclectic03jpeg },
  { style: 'Eclectic', jpeg: eclectic04jpeg },
  { style: 'Eclectic', jpeg: eclectic05jpeg },
  { style: 'Eclectic', jpeg: eclectic06jpeg },
  { style: 'Eclectic', jpeg: eclectic07jpeg },
  { style: 'Eclectic', jpeg: eclectic08jpeg },
  { style: 'Eclectic', jpeg: eclectic09jpeg },
  { style: 'Eclectic', jpeg: eclectic10jpeg },
  // Farmhouse
  { style: 'Farmhouse', jpeg: farmhouse01jpeg },
  { style: 'Farmhouse', jpeg: farmhouse02jpeg },
  { style: 'Farmhouse', jpeg: farmhouse03jpeg },
  { style: 'Farmhouse', jpeg: farmhouse04jpeg },
  { style: 'Farmhouse', jpeg: farmhouse05jpeg },
  { style: 'Farmhouse', jpeg: farmhouse06jpeg },
  { style: 'Farmhouse', jpeg: farmhouse07jpeg },
  { style: 'Farmhouse', jpeg: farmhouse08jpeg },
  { style: 'Farmhouse', jpeg: farmhouse09jpeg },
  // French Country
  { style: 'French Country', jpeg: frenchCountry01jpeg },
  { style: 'French Country', jpeg: frenchCountry02jpeg },
  { style: 'French Country', jpeg: frenchCountry03jpeg },
  { style: 'French Country', jpeg: frenchCountry04jpeg },
  { style: 'French Country', jpeg: frenchCountry05jpeg },
  { style: 'French Country', jpeg: frenchCountry06jpeg },
  { style: 'French Country', jpeg: frenchCountry07jpeg },
  { style: 'French Country', jpeg: frenchCountry08jpeg },
  // Glam
  { style: 'Glam', jpeg: glam01jpeg },
  { style: 'Glam', jpeg: glam02jpeg },
  { style: 'Glam', jpeg: glam03jpeg },
  { style: 'Glam', jpeg: glam04jpeg },
  { style: 'Glam', jpeg: glam05jpeg },
  { style: 'Glam', jpeg: glam06jpeg },
  { style: 'Glam', jpeg: glam07jpeg },
  { style: 'Glam', jpeg: glam08jpeg },
  { style: 'Glam', jpeg: glam09jpeg },
  // Mediterranean
  { style: 'Mediterranean', jpeg: mediterranean01jpeg },
  { style: 'Mediterranean', jpeg: mediterranean02jpeg },
  { style: 'Mediterranean', jpeg: mediterranean03jpeg },
  { style: 'Mediterranean', jpeg: mediterranean04jpeg },
  { style: 'Mediterranean', jpeg: mediterranean05jpeg },
  { style: 'Mediterranean', jpeg: mediterranean06jpeg },
  { style: 'Mediterranean', jpeg: mediterranean07jpeg },
  { style: 'Mediterranean', jpeg: mediterranean08jpeg },
  { style: 'Mediterranean', jpeg: mediterranean09jpeg },
  // Mid-Century Modern
  { style: 'Mid-Century Modern', jpeg: midCenturyModern01jpeg },
  { style: 'Mid-Century Modern', jpeg: midCenturyModern02jpeg },
  { style: 'Mid-Century Modern', jpeg: midCenturyModern03jpeg },
  { style: 'Mid-Century Modern', jpeg: midCenturyModern04jpeg },
  // Spanish
  { style: 'Spanish', jpeg: spanish01jpeg },
  { style: 'Spanish', jpeg: spanish02jpeg },
  { style: 'Spanish', jpeg: spanish03jpeg },
  { style: 'Spanish', jpeg: spanish04jpeg },
  { style: 'Spanish', jpeg: spanish05jpeg },
  { style: 'Spanish', jpeg: spanish06jpeg },
  { style: 'Spanish', jpeg: spanish07jpeg },
  { style: 'Spanish', jpeg: spanish08jpeg },
  // Traditional
  { style: 'Traditional', jpeg: traditional01jpeg },
  { style: 'Traditional', jpeg: traditional02jpeg },
  { style: 'Traditional', jpeg: traditional03jpeg },
  { style: 'Traditional', jpeg: traditional04jpeg },
  { style: 'Traditional', jpeg: traditional05jpeg },
  { style: 'Traditional', jpeg: traditional06jpeg },
  { style: 'Traditional', jpeg: traditional07jpeg },
  { style: 'Traditional', jpeg: traditional08jpeg },
  { style: 'Traditional', jpeg: traditional09jpeg },
  { style: 'Traditional', jpeg: traditional10jpeg },
];
